<template>
    <b-modal v-model="isShowPopup" dialog-class="modal-detail" @hidden="resetModal" scrollable :no-close-on-backdrop=true id="popup-upload" @ok="uploadButtonAction" :okTitle="okTitle" title="Upload Data">
        <b-card>
            <b-row>
                <b-col cols="12">
                    <app-input-fileupload label="File" size="sm" :model.sync="fileupload" />
                </b-col>
            </b-row>
            <b-row v-if="isUploadSuccess">
                <b-col cols="12">
					<b-card no-body>
						<b-tabs card>
							                            <b-tab title="Upload Finish Good Qc Confirmation" active>

                                <b-row v-if="hasFailedDataFinishGoodQcConfirmation">
                                    <b-col>
                                        <b-button variant="danger" v-b-toggle.failed-content class="m-1">Invalid Data ({{ totalFailedFinishGoodQcConfirmation.toLocaleString() }})</b-button>
                                        <b-collapse visible id="failed-content">
                                            <div class="table-corner">
                                                <b-table id="failed-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="finishGoodQcConfirmationsFailed" :fields="fieldsFinishGoodQcConfirmation" :busy="isDataLoading"
                                                         :sort-by.sync="sortByFinishGoodQcConfirmation" :sort-desc.sync="sortDescFinishGoodQcConfirmation" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(qcDate)="row">
													{{ row.item.qcDate | moment("DD-MMM-YYYY") }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col>
                                        <b-button variant="success" v-b-toggle.success-content class="m-1">Valid Data ({{ totalSucceedFinishGoodQcConfirmation.toLocaleString() }})</b-button>
                                        <b-collapse id="success-content">
                                            <div class="table-corner">
                                                <b-table id="success-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="finishGoodQcConfirmations" :fields="fieldsFinishGoodQcConfirmation" :busy="isDataLoading"
                                                         :sort-by.sync="sortByFinishGoodQcConfirmation" :sort-desc.sync="sortDescFinishGoodQcConfirmation" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(qcDate)="row">
													{{ row.item.qcDate | moment("DD-MMM-YYYY") }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                            </b-tab>                            <b-tab title="Upload Finish Good Qc Confirmation Detail" active>

                                <b-row v-if="hasFailedDataFinishGoodQcConfirmationDetail">
                                    <b-col>
                                        <b-button variant="danger" v-b-toggle.failed-content class="m-1">Invalid Data ({{ totalFailedFinishGoodQcConfirmationDetail.toLocaleString() }})</b-button>
                                        <b-collapse visible id="failed-content">
                                            <div class="table-corner">
                                                <b-table id="failed-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="finishGoodQcConfirmationDetailsFailed" :fields="fieldsFinishGoodQcConfirmationDetail" :busy="isDataLoading"
                                                         :sort-by.sync="sortByFinishGoodQcConfirmationDetail" :sort-desc.sync="sortDescFinishGoodQcConfirmationDetail" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col>
                                        <b-button variant="success" v-b-toggle.success-content class="m-1">Valid Data ({{ totalSucceedFinishGoodQcConfirmationDetail.toLocaleString() }})</b-button>
                                        <b-collapse id="success-content">
                                            <div class="table-corner">
                                                <b-table id="success-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="finishGoodQcConfirmationDetails" :fields="fieldsFinishGoodQcConfirmationDetail" :busy="isDataLoading"
                                                         :sort-by.sync="sortByFinishGoodQcConfirmationDetail" :sort-desc.sync="sortDescFinishGoodQcConfirmationDetail" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                            </b-tab>

						</b-tabs>
					</b-card>
                </b-col>
            </b-row>
        </b-card>
        <template #modal-footer="{ ok, cancel }">
            <b-button v-if="isUploadSuccess" size="sm" variant="primary" @click="downloadLog()">
                Download Log
            </b-button>
            <b-button size="sm" variant="success" class="float-right" @click="ok()">
                {{ okTitle }}
            </b-button>
            <b-button size="sm" variant="secondary" class="float-right" @click="cancel()">
                Cancel
            </b-button>
        </template>
        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </b-modal>
</template>
<style lang="scss" scoped>
    .card {
        border: 1px solid rgba(0, 0, 0, 0.125) !important;
    }

    ::v-deep.th-message {
        color: red;
    }

    ::v-deep.modal-footer {
        display: block;
    }
</style>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import { saveAs } from 'file-saver';

import FinishGoodQcConfirmation from '@/models/FinishGoodQcConfirmation/FinishGoodQcConfirmation';
import FinishGoodQcConfirmationList from '@/models/FinishGoodQcConfirmation/FinishGoodQcConfirmationList';
import FinishGoodQcConfirmationFilter from '@/filters/FinishGoodQcConfirmation/FinishGoodQcConfirmationFilter';

import AppInputFileupload from '@/components/AppInputFileupload';

export default {
	props: ['model', 'openPopup','uploadButtonMethod', 'parentId'],
	components : {AppInputFileupload,},
	data() {
		return {
			fileupload: null,
			uploadProcessId: null,
			datas: Array(),
			fieldsFinishGoodQcConfirmation: [
				// {"no" : { "class" : "th-number"}},
				{"class" : "th-id", "label" : "Excel Row", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Id", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "QC By", key: 'processByFirstName', sortable: false},
				{"class" : "th-status", "label" : "QC Date", key: 'qcDate', sortable: false},

				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: false},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessageHtml', sortable: false},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],
			fieldsFinishGoodQcConfirmationDetail: [
				// {"no" : { "class" : "th-number"}},
				{"class" : "th-id", "label" : "Excel Row", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Id", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Finish Good Quality Inspection", key: 'finishGoodQualityInspectionControlCard', sortable: false},
				{"class" : "th-status", "label" : "Control Card", key: 'controlCardControlCardNumber', sortable: false},
				{"class" : "th-status", "label" : "Part", key: 'partPartNumber', sortable: false},

				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: false},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessageHtml', sortable: false},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],

			busy:false,
			isDataLoading: false,
			isBusy : false,
			finishGoodQcConfirmations : [],
			finishGoodQcConfirmationsFailed: [],
			finishGoodQcConfirmationId : '',
			sortByFinishGoodQcConfirmation: '',
			sortDescFinishGoodQcConfirmation: '',
			hasFailedDataFinishGoodQcConfirmation: false,
			totalFailedFinishGoodQcConfirmation: 0,
			totalSucceedFinishGoodQcConfirmation: 0,
			finishGoodQcConfirmationDetails : [],
			finishGoodQcConfirmationDetailsFailed: [],
			finishGoodQcConfirmationDetailId : '',
			sortByFinishGoodQcConfirmationDetail: '',
			sortDescFinishGoodQcConfirmationDetail: '',
			hasFailedDataFinishGoodQcConfirmationDetail: false,
			totalFailedFinishGoodQcConfirmationDetail: 0,
			totalSucceedFinishGoodQcConfirmationDetail: 0,


			processId: '',
			isUploadSuccess: false,
		}
	},
	methods : {
		resetModal() {
			this.datas = Array();
			this.isUploadSuccess = false;
			this.$emit('resetMethod');
		},
		uploadButtonAction(modalEvent) {
			modalEvent.preventDefault();
			this.isBusy = true;
			if (this.isUploadSuccess) {
				let _this = this;
				this.$http.post('finishgoodqcconfirmation/confirmUpload/' + _this.uploadProcessId,
					[],
					).then(async function(response){
						if (response != null) {
							if (response.data != null) {
								_this.resetModal();
								_this.datas = Array();
								_this.fileupload = null;
								_this.isUploadSuccess = false;
							}
						}
						_this.isBusy = false;
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
			} else {
				if (this.fileupload != null) {
					let data = new FormData();
					data.append('file', this.fileupload);
					let _this = this;
					this.$http.post('finishgoodqcconfirmation/upload',
						data,
						{ headers: { 'Content-Type': 'multipart/form-data' } }
					).then(async function(response){
						_this.uploadProcessId = response.data.id;
						_this.isUploadSuccess = true;
						await _this.getFinishGoodQcConfirmationForUpload();
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
				}
			}
		},
		getFinishGoodQcConfirmationForUpload : async function() {
			let _this = this;
			this.$http.get('finishgoodqcconfirmation/uploadresult/' + _this.uploadProcessId)
				.then(async function(response) {
					_this.finishGoodQcConfirmations = [];
_this.finishGoodQcConfirmationDetails = [];


					if (response != null) {
						let result = response.data;
						_this.finishGoodQcConfirmations = result.filter(o => { return o.uploadValidationStatus == "Success"});
                        _this.totalSucceedFinishGoodQcConfirmation = _this.finishGoodQcConfirmations.length;

						_this.finishGoodQcConfirmationsFailed = result.filter(o => { return o.uploadValidationStatus != "Success"});
						_this.hasFailedDataFinishGoodQcConfirmation = true;
						_this.totalFailedFinishGoodQcConfirmation = 0;
						if(_this.finishGoodQcConfirmationsFailed == undefined || _this.finishGoodQcConfirmationsFailed.length === 0) _this.hasFailedDataFinishGoodQcConfirmation = false;
						if(_this.hasFailedDataFinishGoodQcConfirmation) _this.totalFailedFinishGoodQcConfirmation = _this.finishGoodQcConfirmationsFailed.length;
						_this.finishGoodQcConfirmationDetails = [];
						_this.finishGoodQcConfirmationDetailsFailed = [];
						_this.hasFailedDataFinishGoodQcConfirmationDetail = true;
						_this.totalSucceedFinishGoodQcConfirmationDetail = 0;
						result.forEach(function(element) {
							_this.finishGoodQcConfirmationDetails.push(...element.finishGoodQcConfirmationDetail.filter(o => { return o.uploadValidationStatus == "Success"}));
							_this.totalSucceedFinishGoodQcConfirmationDetail = _this.finishGoodQcConfirmationDetails.length;

							_this.finishGoodQcConfirmationDetailsFailed.push(...element.finishGoodQcConfirmationDetail.filter(o => { return o.uploadValidationStatus != "Success"}));
							if(_this.finishGoodQcConfirmationDetailsFailed == undefined || _this.finishGoodQcConfirmationDetailsFailed.length === 0) _this.hasFailedDataFinishGoodQcConfirmationDetail = false;
							if(_this.hasFailedDataFinishGoodQcConfirmationDetail) _this.totalFailedFinishGoodQcConfirmationDetail = _this.finishGoodQcConfirmationDetailsFailed.length;
						});
						_this.isBusy = false;
					}
				})
				.catch(error => {
					_this.$store.dispatch('addErrorMessageGlobal', error);
					_this.isBusy = false;
				});
		},
		downloadLog() {
			let _this = this;
			let url = 'finishgoodqcconfirmation/downloadlog/' + _this.uploadProcessId;
			this.$http.get(url, {responseType: 'blob'}).then(async response => {
				if (response != null) {
					await saveAs(response.data, 'FinishGoodQcConfirmation.xlsx');
				}
			}).catch(error => {
				this.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			});
		}
	},
	beforeMount() {
	},
	mounted(){
	},
	watch: {
		fileupload(newValue, oldValue) {
			this.datas = Array();
			this.isUploadSuccess = false;
		}
	},
	computed: {
		okTitle: {
			get: function() {
				if (this.isUploadSuccess) {
					return "Process";
				}
				return "Upload";
				}
		},
		isShowPopup : {
			get: function () {
				if (this.openPopup) {
					this.filterFinishGoodQcConfirmation = new FinishGoodQcConfirmationFilter();
					return true;
				}
				else return false;
			},
			set: function (newValue) {}
		},
	}
}
</script>
